import React, { useEffect, useState } from 'react';
import API from '../Api';
import SubPageHeader from '../../components/common/SubPageHeader';

// Image Imports
import bookCoverWeCan from '../../assets/images/BookImg-removebg-preview.png'; // We Can If U Will
import bookCoverDawadi from '../../assets/images/IntroPic.jpeg'; // Dawadi Te Ramdham

const BookReleases = () => {
  
  const [data, setData] = useState({});

  useEffect(() => {
    const fetchBookData = async () => {
      try {
        const res = await API.get('get-content/Books/');
        setData(res.data);
      } catch (err) {
        console.error("Error loading book data:", err);
      }
    };
    fetchBookData();
  }, []);

  const resolveImageUrl = (path, fallback) => {
    if (!path) return fallback;
    if (path.startsWith('http')) return path;
    const cleanPath = path.startsWith('/') ? path : `/media/${path}`;
    return `${process.env.REACT_APP_BACKEND_URL || 'http://103.172.92.148:8005'}${cleanPath}`;
  };
  
  return (
    <div className="min-h-screen bg-white font-sans">
      <SubPageHeader title="BOOK RELEASES" />

      {/* --- SECTION 1: WE CAN IF U WILL --- */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-6">
          <div className="flex flex-col lg:flex-row items-start gap-16 max-w-6xl mx-auto">
            
            {/* Book Image */}
            <div className="flex-1 lg:sticky lg:top-32">
              <img 
                src={`${resolveImageUrl(data.book1_img, bookCoverWeCan)}?t=${new Date().getTime()}`} 
                alt="Book 1" 
                className="rounded shadow-2xl w-full max-w-sm mx-auto border border-gray-100"
              />
            </div>

            {/* Book Information */}
            <div className="flex-[1.5] space-y-6 text-[#1a1a1a]">
              <div className="space-y-2">
                <h2 className="text-xl font-bold text-[#003366]">{data.book1_title || "BOOK NAME: WE CAN IF U WILL"}</h2>
                <p className="text-lg font-bold">{data.book1_author || "AUTHOR: OWEE & VINAY SATPUTE"}</p>
                <p className="text-md font-bold text-[#54a50f]">{data.book1_accolades_title || "ACCOLADES: INDIA BOOK OF RECORD'S HOLDER:-"}</p>
              </div>

              <div className="space-y-4 font-bold text-[#003366]">
                {[1, 2].map((i) => (
                  <p key={i}>{data[`book1_acc_${i}`] || (i === 1 ? "1) FIRST FATHER-DAUGHTER DUO TO RECEIVE SCUBA DIVER CERTIFICATION ON SAME DAY" : "2) FASCINATING BOOK ON SCUBA JOURNEY BY FATHER-DAUGHTER DUO")}</p>
                ))}
              </div>

              <div className="space-y-4 text-gray-800 leading-relaxed text-justify">
                <p>{data.book1_p1 || "The book : WE CAN IF U WILL is an attempt to instigate the mind of the reader to think differently..."}</p>
                <p>{data.book1_p2 || "Routine chores and habits will not make us stand apart from the crowd..."}</p>
                <p>{data.book1_p3 || "We as a Dad-Daughter duo dared to explore the third world..."}</p>
              </div>

              <div className="space-y-3 pt-4 border-t border-gray-100">
                <p className="font-bold text-[#003366]">
                  {data.book1_pillars_title || "The book stands on the following four pillars:-"}
                </p>
                
                
                <ul className="space-y-2 font-medium">
                  {['A', 'B', 'C', 'D'].map((char) => (
                    <li key={char} className="flex gap-2">
                      
                      <span className="font-bold">{char})</span>
                     
                      <span>{data[`book1_pillar_${char}`] || "Default Pillar Text"}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <p className="italic font-medium pt-4">
                {data.book1_quote || "The book is for everyone to get inspired, start thinking out of box, create WIN-WIN situations in life..."}
              </p>

              <div className="pt-8">
                <a 
                  href={data.book1_link || "https://www.amazon.in/We-Can-If-Un-Will-ebook/dp/B07CHQW6H3"} 
                  target="_blank" rel="noopener noreferrer"
                  className="inline-block bg-[#003366] text-white px-10 py-4 rounded-lg font-bold uppercase transition-all duration-300 hover:bg-[#54a50f] shadow-xl active:scale-95"
                >
                  {data.book1_btn_text || "Get the Book in Your Collection."}
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* --- SECTION 2: DAWADI TE RAMDHAM --- */}
      {/* --- SECTION 2: DAWADI TE RAMDHAM --- */}
      <section className="py-24 pb-32 bg-[#003366] text-white">
        <div className="container mx-auto px-6">
          <div className="flex flex-col lg:flex-row items-center gap-16 max-w-6xl mx-auto">
            
            {/* Marathi Content (Dynamic) */}
            <div className="flex-[1.5] space-y-6 text-justify">
              <h2 className="text-3xl font-bold border-b border-white/30 pb-4">
                {data.book2_title || '"दावडी ते रामधाम"'}
              </h2>
              
              {/* Intro Lines */}
              <div className="space-y-2 text-lg font-medium">
                {[1, 2, 3, 4].map((i) => (
                  <p key={i}>{data[`book2_line_${i}`] || (i === 1 ? "प्रत्येक कुटुंबाची एक संघर्ष गाथा असते" : i === 2 ? "आपल्या येणाऱ्या पिढ्यांना ती समजली पाहिजे" : i === 3 ? "आपल्या आई-वडिलांची पुण्याई व आशीर्वाद पाठीशी असल्यास आपली नक्कीच सर्वार्थाने भरभराट होते" : "अशीच एक गाथा 'दावडी ते रामधाम' वाचून आपणही एक पुस्तक, आपल्या कुटुंबाचे २०२३! गथे प्रकाशित करूया")}</p>
                ))}
              </div>

              {/* Description Paragraphs */}
              <div className="space-y-4 pt-4">
                <p className="font-bold text-xl">{data.book2_cta_title || "वाचा व अभिप्राय कळवा"}</p>
                <p className="opacity-90 leading-relaxed">{data.book2_p1 || "दावडी ते रामधाम एक पुस्तक नसून आठ दशकांच्या शब्दांत बांधलेल्या आठवणींचा मौल्यवान ठेवा आहे..."}</p>
                <p className="opacity-90 leading-relaxed">{data.book2_p2 || "ह्या पुस्तकामुळे आयुष्याची उजळणी झाली. आयुष्यातल्या वेगवेगळ्या टप्प्यात केलेले पराक्रम..."}</p>
              </div>

              <div className="pt-8 flex justify-center">
                    <a
                        href={data.book2_link || "https://www.amazon.in/dp/B0BSLHPBJL"}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="
                            inline-flex
                            items-center
                            justify-center
                            w-full
                            sm:w-auto
                            max-w-full
                            bg-white
                            text-[#003366]
                            px-5
                            sm:px-8
                            md:px-10
                            py-3
                            md:py-4
                            rounded-lg
                            font-bold
                            text-sm
                            sm:text-base
                            uppercase
                            text-center
                            leading-relaxed
                            transition-all
                            hover:bg-[#54a50f]
                            hover:text-white
                            shadow-xl
                            active:scale-95
                        "
                    >
                        {data.book2_btn_text || "अधिक माहितीसाठी Click here"}
                    </a>
              </div>
            </div>

            {/* Book Image */}
            <div className="flex-1">
              <img 
                src={`${resolveImageUrl(data.book2_img, bookCoverDawadi)}?t=${new Date().getTime()}`} 
                alt="Dawadi Te Ramdham Image" 
                className="rounded-lg shadow-2xl w-full max-w-md mx-auto border-4 border-white/20"
              />
            </div>
          </div>
        </div>
      </section>

      <div className="h-20 bg-white"></div> 
    </div>
  );
};

export default BookReleases;